import React from 'react';
import { Link } from 'react-router-dom';
import { Target, Palette, TrendingUp, ArrowRight } from 'lucide-react';
import { servicesOverview } from '../../data/mockData';

export const ServicesOverview = () => {
  const icons = {
    Target,
    Palette,
    TrendingUp
  };

  return (
    <section className="py-24 bg-[rgb(17,17,19)]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What We Do
          </h2>
          <p className="text-xl text-[rgb(218,218,218)] max-w-3xl mx-auto">
            Comprehensive digital marketing solutions tailored for healthcare and wellness brands
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {servicesOverview.map((service) => {
            const Icon = icons[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-[rgb(26,28,30)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:border-[rgb(0,250,99)] overflow-hidden"
              >
                {/* Top Accent Border */}
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-[rgb(0,250,99)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-[rgba(0,250,99,0.1)] flex items-center justify-center mb-6 group-hover:bg-[rgb(0,250,99)] transition-colors duration-300">
                  <Icon
                    size={28}
                    className="text-[rgb(0,250,99)] group-hover:text-[rgb(17,17,19)] transition-colors duration-300"
                  />
                </div>

                {/* Content */}
                <h3 className="text-2xl font-semibold text-white mb-4 group-hover:text-[rgb(0,250,99)] transition-colors">
                  {service.title}
                </h3>
                <p className="text-[rgb(161,161,170)] leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Link */}
                <Link
                  to={service.link}
                  className="inline-flex items-center space-x-2 text-[rgb(0,250,99)] font-medium group/link"
                >
                  <span>Learn More</span>
                  <ArrowRight
                    size={18}
                    className="group-hover/link:translate-x-1 transition-transform"
                  />
                </Link>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-block px-8 py-4 bg-transparent text-white rounded-xl font-semibold text-lg border-2 border-[rgb(63,63,63)] hover:border-[rgb(0,250,99)] hover:text-[rgb(0,250,99)] hover:bg-[rgba(0,250,99,0.1)] transition-all duration-200"
          >
            View All Services
          </Link>
        </div>
      </div>
    </section>
  );
};
